import { render, staticRenderFns } from "./boxDoorOpen.vue?vue&type=template&id=20f73962&scoped=true&"
import script from "./boxDoorOpen.vue?vue&type=script&lang=js&"
export * from "./boxDoorOpen.vue?vue&type=script&lang=js&"
import style0 from "./boxDoorOpen.vue?vue&type=style&index=0&id=20f73962&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f73962",
  null
  
)

export default component.exports